var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8322 0.35083H3.15724C1.92285 0.35083 0.918701 1.41123 0.918701 2.71479V13.8592L5.39578 11.4952L9.87287 13.8592V7.78041H13.0708V2.71479C13.0708 1.41123 12.0666 0.35083 10.8322 0.35083ZM7.31453 6.42958H6.03537V7.78041H4.7562V6.42958H3.47703V5.07875H4.7562V3.72791H6.03537V5.07875H7.31453V6.42958ZM11.7916 6.42958H9.87287V2.71479C9.87287 2.15622 10.3033 1.70166 10.8322 1.70166C11.3612 1.70166 11.7916 2.15622 11.7916 2.71479V6.42958Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3);
export default __webpack_public_path__ + "static/media/circle3.aef3cbade9ca6fad16e02d8b1ac3137a.svg";
export { ForwardRef as ReactComponent };